var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { DateInput } from 'ziphy-web-shared/basic/lib/forms/fields';
import styles from './DropdownDate.module.scss';
const DropdownDate = forwardRef((_a, ref) => {
    var { mode = ['xs'], placeholder } = _a, fieldProps = __rest(_a, ["mode", "placeholder"]);
    const { t } = useTranslation();
    return (_jsx("div", Object.assign({ className: styles.container }, { children: _jsx(DateInput, Object.assign({ ref: ref, 
            // label={placeholder ? placeholder : t('label.other')}
            mode: mode }, fieldProps, { readonly: true })) })));
});
export default observer(DropdownDate);
